import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ReportsService } from '../../reports/reports.service';
import { ElementData } from '../../models/elementdata';
import { version } from 'core-js/library/web/timers';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'formmodal',
    styleUrls: ['./formmodal.component.scss'],
    templateUrl: './formmodal.component.html'
})
export class FormModalComponent {
    @Input() formTemplateData: any = {};
    @Output() onBtnSelection = new EventEmitter<boolean>();
    langSub: Subscription;
    expanded = false;
    disabled = true;
    prodId: number;
    versionId: number;
    counts: Array<number> = [1];
    clone: boolean = false;
    subCategoriesClone: any;
    arrayOfStrings: any[];
    activeClass: string;
    catagoryDescripation: string;
    categorySortaData:ElementData = ElementData.getVersiondata("New Maximum Category"); 
    subCategorySortaData:ElementData = ElementData.getVersiondata("New Maximum SubCategory");
    allCategoriesData:any;
    selectedCategories:any;
    autoPopulateNumber:number = 12;
    

    formModalHandler(btnOutput: boolean) {
        this.onBtnSelection.emit(btnOutput);
        this.formTemplateData.state = false;
    }

    constructor(private reportservice: ReportsService, private translateService: TranslateService) {
        this.categorySortaData.hidden = true;

    }

    onVersionChange(selectedValue) {
        if (this.formTemplateData.isMaximum === true) {
            let productid = this.prodId;
            let versionid = this.formTemplateData.elements[3].selectedValue.id// selectedValue.id
            this.setTargetVersionData(productid.toString(), versionid);
            this.getSelcProductCategoriesByProductAndVersionid(productid, versionid);
            this.formTemplateData.elements[4].options = [];
        }
    }
    onChangeProd(selectedValue) {
        this.catagoryDescripation = " ";
        if (selectedValue.cat == 1) {
            if (selectedValue.id > 0) {
                this.prodId = selectedValue.id;
                if (this.formTemplateData.isMaximum === false) {
                    if (selectedValue.isprod === true) {
                        this.setSubTitle(selectedValue);
                        // new product versions which are not having configmax set
                        this.getSelProductVersions(selectedValue.id, selectedValue.isprod, 2);
                        if (this.clone === true) {
                            this.getcopyProductdetailsonchange();
                        }
                    } else {
                        // product versions which are having configmax set
                        this.getSelProductVersions(selectedValue.id, selectedValue.isprod, 3);
                    }
                } else {
                    /* product versions which are having configmax set */
                    this.getSelProductVersions(selectedValue.id, selectedValue.isprod, 3);                }
            } else {
                this.setVersionArray([], 0, 1);
                this.setVersionArray([], 2, 4);
                this.setVersionArray([], 0, 3);
                this.disabled = true;
            }
        } else {
            if(!selectedValue.isSelectCat)
            this.setCategoriesOnChnageProd(selectedValue);
            else {
            this.onChangeCategory(selectedValue);
            }
        }
        
    }

    setSubTitle(selectedValue) {
        if (selectedValue.id > 0) {
            this.formTemplateData.subTitle = selectedValue.value;
        } else {
            this.formTemplateData.subTitle = " ";
        }
    }
   
    getSelProductVersions(prodId, isProd, urlIndex): void {
        this.reportservice.getProductVersions(prodId, urlIndex)
            .subscribe(vmwareproductsVersions => {
                let filteredVersionsRight: Array<any> = [];
                vmwareproductsVersions.forEach(vmwareVersions => {
                    if(vmwareVersions.support === true){
                        filteredVersionsRight.push(vmwareVersions);
                    }
                })
                this.loadProductVersions(isProd, filteredVersionsRight);
            },
                err => {
                    // Log errors if any
                    if (isProd === true) {
                        this.setVersionArray([], 0, 1);
                    } else {
                        this.setVersionArray([], 2, 4);
                    }
                    console.log(err)
                });
    }

    loadProductVersions(isProd, vmwareproductsVersions): void {
        let arr: any = new Array();
        if (vmwareproductsVersions.length === 0) {
            this.disabled = true;
        } else {
            this.disabled = false;
        }

        vmwareproductsVersions.forEach(element => {
            arr.push({
                id: element.id, value: element.rmVmwPrdRelVersion, cat: 0, checked: false
            });
        });
        let version = arr[0];
        if (this.formTemplateData.isMaximum === false) {
            if (isProd === false) {
                this.setVersionArray(arr, 2, 4);
            } else if (isProd === true) {
                this.setVersionArray(arr, 0, 1);
            }
            if ((this.formTemplateData.elements[1].options != undefined &&
                this.formTemplateData.elements[1].options.length === 0) ||
                (this.formTemplateData.elements[4].options != undefined &&
                    this.formTemplateData.elements[4].options.length === 0)) {
                this.disabled = true;
            }
        } else {
            this.setCategoriesOnChnageProd(version);
            this.setVersionArray(arr, 3, 1);
            this.setTargetVersionData(this.formTemplateData.elements[0].selectedValue.id.toString(),
                this.formTemplateData.elements[1].selectedValue.id);
        }
    }
    setTargetVersionData(id: string, versionId: number): void {
        this.reportservice.getProductVersions(id, 3).subscribe(vmwareproductsMaximums => {
            let arr: any = new Array();
            arr.push({ id: 0, value: this.translateService.instant('select'), cat: 0, checked: false });
            vmwareproductsMaximums.forEach(element => {
                if (element.id == versionId) {
                } else {
                    arr.push({ id: element.id, value: element.rmVmwPrdRelVersion, cat: 0, checked: false });
                }
            });
            this.formTemplateData.elements[3].options = arr;
        },
            err => {
                console.log(err);
            });
    }
    setVersionArray(arr: any, cat: number, index: number): void {
        let newarr: any = new Array();
        arr.forEach(element => {
            newarr.push({
                id: element.id, value: element.rmVmwPrdRelVersion, cat: cat, checked: false
            });
        });
        this.formTemplateData.elements[index].options = arr;
        this.formTemplateData.elements[index].selectedValue = arr[0];
    }
    setSubcatgoryArray(arr: any, cat: number, index: number): void {
        let newarr: any = new Array();
        this.disabled = false;
        arr.forEach(element => {
            newarr.push({
                id: element.id, value: element.subCategory, checked: true
            });
        });
        this.subCategoriesClone = newarr;
        this.formTemplateData.elements[index].options = newarr;
        this.formTemplateData.elements[index].selectedValue = newarr[0];
    }

    onClicked(option, event) {
        if (option.value === this.translateService.instant('newStatus')) {
            this.clone = false;
            this.disabled = false;
            if (this.formTemplateData.isMaximum === false) {
                this.createconfigSet(true, false);
            } else {
                this.createMaximum(true, false);
                this.hideSorDetails(false);
            }
        } else {
            this.clone = true;
            if (this.formTemplateData.isMaximum === false) {
                this.createconfigSet(false, true);
                this.getcopyProductdetailsonchange();
                this.setVersionArray([], 2, 4);
                this.disabled = true;
            } else {
                this.createMaximum(false, true);
                this.hideSorDetails(true);
            }
        }
    }

    getcopyProductdetailsonchange() {
        this.getProductInConfigSet();
    }

    getProductInConfigSet(): any {
        let arr = [];
        this.reportservice.getProducts(this.reportservice.roleIds).subscribe(
            prodsinconfig => {
                arr = prodsinconfig;
                let copyarr: any = this.getcopyArray(prodsinconfig,
                    this.formTemplateData.elements[0].selectedValue, false, true);
                this.formTemplateData.elements[3].options = copyarr;
                this.formTemplateData.elements[3].selectedValue = copyarr[0];
                this.setVersionArray([], 2, 4);
            },
            err => {
                console.log(err);
            }
        );
    }

    getcopyArray(arr: any, elementSelected, prod, copy): any {
        let newarr = new Array();
        newarr.push({ id: 0, value: this.translateService.instant('select'), cat: 1, isprod: prod, iscopy: copy });
        arr.forEach(element => {
            newarr.push({ id: element.id, value: element.rmVmwProduct, cat: 1, isprod: prod, iscopy: copy });
        });
        return newarr;
    }

    createconfigSet(hidden: boolean, checked: boolean) {
        this.formTemplateData.elements[3].hidden = hidden;
        this.formTemplateData.elements[4].hidden = hidden;
        this.formTemplateData.elements[2].options[1].isChecked = checked;
        this.formTemplateData.elements[2].options[0].isChecked = hidden;
    }

    createMaximum(hidden: boolean, checked: boolean) {
        this.formTemplateData.elements[3].hidden = hidden;
        this.formTemplateData.elements[2].options[0].isChecked = hidden;
        this.formTemplateData.elements[2].options[1].isChecked = checked;
        this.formTemplateData.elements[4].hidden = hidden;
        this.formTemplateData.elements[5].hidden = checked;
        this.formTemplateData.elements[6].hidden = checked;
    }

    onChecked(option, event) {
        if (option.cat == 0) {
            this.setcheckbox(3, event);
        } else if (option.cat == 2) {
            this.setcheckbox(4, event);
        }
    }

    setcheckbox(index, event) {
        for (let i = 0; i < this.formTemplateData.elements[index].options.length; i++) {
            if (this.formTemplateData.elements[index].options[i].value == event.target.value) {
                this.formTemplateData.elements[index].options[i].checked = event.target.checked;
            }
        }
    }

    setCloneCat(tester: any) {
        let id = this.formTemplateData.elements[0].selectedValue.id;
        let versionid = this.formTemplateData.elements[3].selectedValue.id;
        this.reportservice.getMaximumCategoriesByProductIdAndVersionId(this.prodId, id)
            .subscribe(vmwareproductsMaximums => {
                let arr: any = new Array();
                vmwareproductsMaximums.forEach(element => {
                    arr.push({ id: element.id, value: element.category, cat: 0, checked: false });
                });
                this.formTemplateData.elements[4].options = arr;
            },
                err => {
                    console.log(err)
                });
        let productid = this.prodId;
        this.getSelcProductCategoriesByProductAndVersionid(productid, versionid);
    }

    getSelcProductCategoriesByProductAndVersionid(prodid: number, versionid: number) {
        this.reportservice.getMaximumCategoriesByProductIdAndVersionId(prodid, versionid)
            .subscribe(vmwareproductsMaximums => {

                let arr: any = new Array();
                vmwareproductsMaximums.forEach(element => {
                    arr.push({ id: element.id, value: element.category, cat: 0, checked: false });
                });
                
                this.getUniqueCategoriesByProductAndVersionid(arr);
            },
                err => {
                    console.log(err)
                    this.formTemplateData.elements[4].options = [];
                });
    }

    getUniqueCategoriesByProductAndVersionid(arrvalue) {
        let uniquearr: any = new Array();
        let versionid = this.formTemplateData.elements[1].selectedValue.id;
        this.reportservice.getMaximumCategoriesByProductIdAndVersionId(this.prodId, versionid)
            .subscribe(vmwareproductsMaximums => {

                let arr: any = new Array();
                vmwareproductsMaximums.forEach(element => {
                    arr.push({ id: element.id, value: element.category, cat: 0, checked: false });
                });
                var uniqueArray = arrvalue.filter(function (obj) {
                    return !arr.some(function (obj2) {
                        return obj.value == obj2.value;
                    });
                });
                if (uniqueArray.length === 0 && arrvalue.length != null) {
                    this.catagoryDescripation = "All categories exists in target product ( " +
                        this.formTemplateData.elements[1].selectedValue.value + " )";
                }
                if (this.formTemplateData.elements[1].selectedValue.value === this.formTemplateData.elements[3].selectedValue.value) {
                    this.catagoryDescripation = " ";
                }
                this.formTemplateData.elements[4].options = uniqueArray;
                if (uniqueArray.length > 0 )
                this.disabled = false;
            },
                err => {
                    console.log(err)
                    this.formTemplateData.elements[4].options = [];
                });

    }
    getSuggestData(event: any) { // without type info
        if (event.target.value === '') {
            this.activeClass = '';
        } else {
            this.activeClass = 'active';
            this.reportservice.getSuggestData(event.target.value)
                .subscribe(suggestData => {
                    this.arrayOfStrings = suggestData;
                },
                    err => {
                        console.log(err);
                    });
        }
    }

    closeDropDown() {
        this.activeClass = '';
    }
    setCategoriesOnChnageProd(selectedValue) {
        if (selectedValue.value != this.translateService.instant('default') &&
            selectedValue.value != this.translateService.instant('before') &&
            selectedValue.value != this.translateService.instant('after')) {
            this.reportservice.getMaximumCategoriesByProductIdAndVersionId(this.prodId, selectedValue.id)
                .subscribe(vmwareproductsMaximums => {
                    let arr: any = new Array();
                    let subcatarr: any = new Array();
                    let catarr: any = new Array();;
                    catarr.push({ id: -1, value: this.translateService.instant('select'), cat: 0, sortorder: 0, checked: false, isCat: true, isSelectCat: true })
                    this.allCategoriesData = vmwareproductsMaximums;
                    vmwareproductsMaximums.forEach(element => {
                        arr.push({ id: element.id, value: element.category, cat: 0, sortorder: element.catSortorder, checked: false, isCat: true, isSelectCat: true });
                    });
                    this.selectedCategories = arr;
                    catarr.push.apply(catarr, arr);
                    this.formTemplateData.elements[6].options = catarr;
                    this.formTemplateData.elements[6].selectedValue = catarr[0];
                    this.setCategories(arr, catarr[0]);
                    this.categorySortaData.hidden = true;
                    if (this.formTemplateData.elements[6].selectedValue.id > 0)
                        this.onChangeCategory(arr[0]);
                },
                err => {
                    // Log errors if any
                    console.log(err)
                });
        } else {
            this.onChangeSetSort(selectedValue);
        }

    }

    setCategories(arr: any, selectedItem: any) {
        if (arr != null) {
            let catArr: any = new Array();
            arr.forEach(element => {
                if (selectedItem != undefined && selectedItem.id != element.id)
                    catArr.push(element);
            });
            this.categorySortaData.options = catArr;
            this.categorySortaData.selectedValue = catArr[0];
            this.formTemplateData.elements[7].selectedValue = this.formTemplateData.elements[7].options[0];
            this.disabled = true;
        }
    }
    onChangeSetSort(element): void {
        if (element.isCat) {
            if (element.value === this.translateService.instant('default'))
                this.categorySortaData.hidden = true;
            else
                this.categorySortaData.hidden = false;
        }
        else {
            if (element.value === this.translateService.instant('default'))
                this.subCategorySortaData.hidden = true;
            else
                this.subCategorySortaData.hidden = false;

        }
    }

    onChangeCategory(selectedElement): void {
        this.setCategories(this.selectedCategories, selectedElement);
        let subcatarr: any = new Array();
        this.allCategoriesData.forEach(element => {
            if (element.subcategories != undefined && element.subcategories.length >= 0 && selectedElement.id == element.id) {
                element.subcategories.forEach(subelement => {
                    subcatarr.push({ id: subelement.id, value: subelement.subCategory, sortorder: subelement.sortOrder, catId: element.id, isCat: false });
                });
            }
        });
        this.subCategorySortaData.options = subcatarr;
        this.subCategorySortaData.selectedValue = subcatarr[0];
        this.formTemplateData.elements[10].selectedValue = this.formTemplateData.elements[10].options[0];
        this.subCategorySortaData.hidden = true;
        if ((selectedElement.id == -1 && this.formTemplateData.elements[5].selectedValue.length === 0) ||
            (selectedElement.id > 0 && this.formTemplateData.elements[9].selectedValue.length === 0))
            this.disabled = true;
        else
            this.disabled = false;
            if(this.formTemplateData.elements[6].selectedValue.id > 0 ) 
            this.formTemplateData.elements[5].isdisabled =true;
            else
            this.formTemplateData.elements[5].isdisabled =false;
        }

    onChangeCategorySetSort(element): void {
        this.formTemplateData.elements[7].selectedValue.sort = element.sortorder;
    }

    onChangeSubCategorySetSort(element): void {
        this.formTemplateData.elements[10].selectedValue.sort = element.sortorder;
    }

    hideSorDetails(hidden: boolean) {
        this.formTemplateData.elements[6].hidden = hidden;
        this.formTemplateData.elements[7].hidden = hidden;
        this.formTemplateData.elements[8].hidden = hidden;
        this.formTemplateData.elements[9].hidden = hidden;
        this.formTemplateData.elements[10].hidden = hidden;
        this.formTemplateData.elements[11].hidden = hidden;

    }
    validate(event: any): void {
        if ((event.target.placeholder === this.translateService.instant('newMaxCat') &&
            (event.target.value.length == 0 && this.formTemplateData.elements[6].selectedValue.id == -1)) ||
            (event.target.placeholder === this.translateService.instant('newMaxSubCat') &&
                (event.target.value.length == 0 && this.formTemplateData.elements[6].selectedValue.id > 0)))
            this.disabled = true;
        else
            this.disabled = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/formmodal/formmodal.component.ts